import { Col, Container, Row } from "reactstrap";
import BasicTrees from "./BasicTrees";
import DisabledTree from "./DisabledTree";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, TreeTitle } from "../../../Constants/Constants";

const TreeViewContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TreeTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <Col md="6">
            <BasicTrees />
          </Col>
          <Col md="6">
            <DisabledTree />
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default TreeViewContainer;
